import React, { useEffect, useState } from 'react';
import '../../styles/FinalScreen.css';
import cake1 from '../../assets/milestone1.png';
import cake2 from '../../assets/milestone2.png';
import cake3 from '../../assets/milestone3.png';
import cake4 from '../../assets/milestone4.png';
import cake5 from '../../assets/milestone5.png';

export default function FinalScreen({
  score,
  background,
  title,
  scoreDisplay
}) {
  const [animateCake, setAnimateCake] = useState(false);

  useEffect(() => {
    setTimeout(() => setAnimateCake(true), 100);
  }, []);

  const getCakeByScore = (score) => {
    if (score >= 90) return cake5;
    if (score >= 62) return cake4;
    if (score >= 54) return cake3;
    if (score >= 38) return cake2;
    return cake1;
  };

  const selectedCake = getCakeByScore(score);

  return (
    <div
      className={`
        final-screen
        final-screen--${background?.type ?? 'plain'}
        quiz-card
      `}
    >
      {background?.type === 'heroes' && background?.heroesImage && (
        <img
          src={background.heroesImage}
          alt=""
          className="final-screen-heroes"
        />
      )}

      <div className="final-content">

        <div
          className={`
            final-score
            font-${title?.fontSize ?? 'xl'}
          `}
        >
          <p>Результат:</p>
          <span>{score ?? scoreDisplay}</span>
        </div>
 
        <div className={`final-cake ${animateCake ? 'animate' : ''}`}>
          <img src={selectedCake} alt="" />
        </div>

      </div>
    </div>
  );
}